import React, {useContext, useState} from 'react';
import CryptoJS from 'crypto-js';
import {format} from 'date-fns'
import STC from '../../../../../../../../../STCLibrary/STCFactory/STCFactory';
import { useNavigate, useParams } from 'react-router-dom';
import { PassengerAPI } from '../../../../../../../../../API/PassengerAPIs/PassengerAPIs';
import ApiResponseHandler from '../../../../../../../../../STCLibrary/ApiResponseHandler/ApiResponseHandler';
import NotificationContext from '../../../../../../../../../STCLibrary/NotificationSystem/NotificationContext';
import { AccountContext } from '../../../../../../../PageRoutes/PageRoutes';
import { PayNowReportAPIs } from '../../../../../../../../../API/PayNowReportAPIs/PayNowReportAPIs';
import ColouredLoadingSymbol from '../../../../../../../../../STCLibrary/LoadingAnimation/ColouredLoadingSymbol/ColouredLoadingSymbol';
import './PaymentForm.css';

export default function PaymentForm({passenger, paymentAmount, bookingID, tour, date, latestPayment}){

    const routeParams = useParams();
    const [chargetotal, setChargeTotal] = useState(parseFloat((paymentAmount)).toFixed(2));
    const navigate = useNavigate();
    const {accountDetails} = useContext(AccountContext);
    const notificationCtx = useContext(NotificationContext);

    const [sending, setSending] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [sendingAuthiPay, setSendingAuthiPay] = useState(false);

  

    const authenticateTransaction = "true";
    const checkoutoption = "combinedpage";
    const currency =	tour.currency === "GBP" ? "826" : "978";
    const customParam_bookingId = bookingID;
    const customParam_dateofbirth = passenger.dateOfBirth;
    const customParam_emailaddress = accountDetails.email;
    const customParam_gender = passenger.gender;
    const customParam_passengerid = passenger.id;
    const customParam_schoolname = tour.schoolName;
    const customParam_studentname = passenger.firstName + ' ' + passenger.surname;
    const hash_algorithm = process.env.REACT_APP_HASH_ALGO;
    const mode = "payonly";
    const oid = routeParams.userID + '-'+format(new Date(date), "T");
    const responseFailURL = process.env.REACT_APP_RESPONSE_URL;
    const responseSuccessURL = process.env.REACT_APP_RESPONSE_URL;
    const sharedsecret = process.env.REACT_APP_SHARED_SECRET;
    const storename =	process.env.REACT_APP_STORE_ID;
    // const timezone = "Europe/Dublin";
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
    const transactionNotificationURL = process.env.REACT_APP_NOTIFICATION_URL;
    // const transactionNotificationURL = 'N/A';
    const trxOrigin = "ECI";
    const txndatetime = format(new Date(), "yyyy:LL:dd-HH:mm:ss");
    const txntype = "sale";

    const generateHashExtended = () => {
        let stringToExtendedHash = `${authenticateTransaction}|${chargetotal}|${checkoutoption}|${currency}|${customParam_bookingId}|${customParam_dateofbirth}|${customParam_emailaddress}|${customParam_gender}|${customParam_passengerid}|${customParam_schoolname}|${customParam_studentname}|${hash_algorithm}|${mode}|${oid}|${responseFailURL}|${responseSuccessURL}|${storename}|${timezone}|${transactionNotificationURL}|${trxOrigin}|${txndatetime}|${txntype}`;
        const hashHMACSHA256 = CryptoJS.HmacSHA256(stringToExtendedHash, sharedsecret)
        const hashExtended = CryptoJS.enc.Base64.stringify(hashHMACSHA256);
        return hashExtended;
    }
    // const handleSubmit = (e) =>{
        
    //     e.preventDefault();
    //     e.stopPropagation();

    //     //Lucas POST api to log PAY NOW CLICK

    //     if(!window.confirm('Are you sure you want to make a payment of ' + chargetotal + ' for ' + passenger.firstName + ' ' + passenger.surname)){
    //         ////Lucas PUT API to update 'Pay now action ' - id /  oid / CANCELLED / null / null
    //         return
    //     }

    //     //Lucas PUT API to update 'Pay now action' - id / oid / CONFIRMED / null / null

    //     if(sending) return;

    //     setSending(true);
    
    //     const postJSON = {
    //         paymentOrderId: oid,
    //         payerId: routeParams.userID,
    //         passengerId: passenger.id,
    //         transactionAttemptedTime: new Date(),
    //         // transactionAttemptedTime: date,
    //         transactionAmount: chargetotal,
    //         currency: tour.currency,
    //         bookingId: bookingID,
    //         // portalPaymentId: 405,
    //         portalTransactionId: 0,
    //         transactionStatus: 0
    //     }

    //     PassengerAPI.PostPaymentSession(postJSON)
    //     .then((response) => {
    //         if(response.status === 200 && (response.data.paymentOrderId === oid)){
    //             //Lucas PUT API to confirm created payemtn session id / oid / CONFIRMED / SUCCESS / null
    //             PassengerAPI.GetPaymentSession(oid)
    //             .then((resp) => {
    //                 console.log(resp);
    //                 //Lucas PUT API to confirm created payemtn session id / oid / CONFIRMED / FAILED / SUCCESS
    //                 if(resp.status === 200 && (resp.data.paymentOrderId === oid)){
    //                     document.getElementById("paymentForm").method = "POST";
    //                     document.getElementById("paymentForm").action = process.env.REACT_APP_AUTHIPAY_URL;
    //                     document.getElementById("paymentForm").submit();
    //                 }
    //                 else{
    //                     //Lucas PUT API to confirm created payemtn session id / oid / CONFIRMED / FAILED / FAILED
    //                     ApiResponseHandler({status: 404, statusText: 'Failed to redirect. Please try again.'}, notificationCtx, navigate);
    //                 }
    //             })
    //             .catch((err) => {
    //                 console.log(err);
    //                 setSending(false);
    //                 ApiResponseHandler(err.response, notificationCtx, navigate);
    //             })
                
    //         }
    //         else{
    //             //Lucas PUT API to confirm created payemtn session id / oid / CONFIRMED / FAILED / null
    //             ApiResponseHandler({status: 404, statusText: 'Failed to redirect. Please try again.'}, notificationCtx, navigate);
    //         }
    //     })
    //     .catch((err) => {
    //         console.log(err);
    //         setSending(false);
    //         ApiResponseHandler(err.response, notificationCtx, navigate);
    //     })
    //     .finally(() => {
    //         setSending(false);
    //     })

        
    // }

    const handleClickPayNow = async (e) => {

        try{
            e.preventDefault();
            e.stopPropagation();

            if(sending) return;
            setSending(true);
            const postPayNowJSON = {
                "oid": oid,
                "pay_now_action": "",
                "post_payment_session": "",
                "get_payment_session": "",
                "returned_error": ""
            }
            try{
                await PayNowReportAPIs.PostPayNowReport(postPayNowJSON)
            }
            catch (err) {
                throw err;
            }
            setShowModal(true);
        }
        catch (err) {
            console.log(err);
            setSending(false);
            ApiResponseHandler(err.response, notificationCtx, navigate);
        } 
    }

    const handleConfirmPayment = async () => {
        
        try{
            setSendingAuthiPay(true);
        
            //Lucas POST api to log PAY NOW CLICK
            const postPayNowJSON = {
                "oid": oid,
                "pay_now_action": "CONFIRMED",
                "post_payment_session": "",
                "get_payment_session": "",
                "returned_error": ""
            }
        
            await PayNowReportAPIs.PostPayNowReport(postPayNowJSON)
        
            const postJSON = {
                paymentOrderId: oid,
                payerId: routeParams.userID,
                passengerId: passenger.id,
                transactionAttemptedTime: new Date(),
                // transactionAttemptedTime: date,
                transactionAmount: chargetotal,
                currency: tour.currency,
                bookingId: bookingID,
                // portalPaymentId: 405,
                portalTransactionId: 0,
                transactionStatus: 0
            }

            try{
                const response = await PassengerAPI.PostPaymentSession(postJSON);
            
                if(response.status === 200 && (response.data.paymentOrderId === oid)){
                    //Lucas PUT API to confirm created payemtn session id / orderID / CONFIRMED / SUCCESS / null
                    postPayNowJSON.post_payment_session = 'SUCCESS';
                    await PayNowReportAPIs.PostPayNowReport(postPayNowJSON)

                    try{
                        const resp = await PassengerAPI.GetPaymentSession(oid)
                        //Lucas PUT API to confirm created payemtn session id / oid / CONFIRMED / FAILED / SUCCESS
                        postPayNowJSON.get_payment_session = 'SUCCESS';
                        await PayNowReportAPIs.PostPayNowReport(postPayNowJSON)
                        if(resp.status === 200 && (resp.data.paymentOrderId === oid)){
                            document.getElementById("orderId").value = resp.data.paymentOrderId;
                            document.getElementById("paymentForm").method = "POST";
                            document.getElementById("paymentForm").action = process.env.REACT_APP_AUTHIPAY_URL;
                            document.getElementById("paymentForm").submit();
                        }
                        else{
                            //Lucas PUT API to confirm created payemtn session id / oid / CONFIRMED / FAILED / FAILED
                            postPayNowJSON.get_payment_session = 'FAILED';
                            await PayNowReportAPIs.PostPayNowReport(postPayNowJSON)
                            ApiResponseHandler({status: 404, statusText: 'Failed to redirect. Please try again.'}, notificationCtx, navigate);
                        }
                    
                    }
                    catch (err)  {
                        console.log(err);
                        postPayNowJSON.get_payment_session = 'FAILED';
                        postPayNowJSON.returned_error = JSON.stringify(err.response);
                        await PayNowReportAPIs.PostPayNowReport(postPayNowJSON)
                        setSending(false);
                        ApiResponseHandler(err.response, notificationCtx, navigate);
                    }
                    
                }
                else{
                    //Lucas PUT API to confirm created payemtn session id / oid / CONFIRMED / FAILED / null
                    postPayNowJSON.post_payment_session = 'FAILED';
                    postPayNowJSON.returned_error = JSON.stringify(response);
                    await PayNowReportAPIs.PostPayNowReport(postPayNowJSON)
                    ApiResponseHandler({status: 404, statusText: 'Failed to redirect. Please try again.'}, notificationCtx, navigate);
                }
            }
            catch (err){
                postPayNowJSON.post_payment_session = 'FAILED';
                postPayNowJSON.returned_error = JSON.stringify(err.response);
                await PayNowReportAPIs.PostPayNowReport(postPayNowJSON);
            }
            
         
        }
        catch (err) {
            console.log(err);
            setSending(false);
            setSendingAuthiPay(false);
            ApiResponseHandler(err.response, notificationCtx, navigate);
        } 
        finally{
            
            setSending(false);
        }

        
    }

    const handleCancelPayNow = async () => {
        try{
        const postPayNowJSON = {
            "oid": oid,
            "pay_now_action": "CANCELLED",
            "post_payment_session": "",
            "get_payment_session": "",
            "returned_error": ""
        }
        await PayNowReportAPIs.PostPayNowReport(postPayNowJSON)
            setShowModal(false);
        }
        catch (err) {
            console.log(err);
            setSending(false);
            ApiResponseHandler(err.response, notificationCtx, navigate);
        } 
        finally{
            setSending(false);
        }
    }

    return(
        // <form method="POST" action={process.env.REACT_APP_AUTHIPAY_URL}>
        <>
        <form id='paymentForm' onSubmit={handleClickPayNow}>
            <input name="checkoutoption" type="hidden" value={checkoutoption} readOnly/>
            <input name="currency" type="hidden" value={currency} readOnly/>
            <input name="customParam_bookingId" type="hidden" value={customParam_bookingId} readOnly/>
            <input name="customParam_dateofbirth" type="hidden" value={customParam_dateofbirth} readOnly/>
            <input name="customParam_emailaddress" type="hidden" value={customParam_emailaddress} readOnly/>
            <input name="customParam_gender" type="hidden" value={customParam_gender} readOnly/>
            <input name="customParam_passengerid" type="hidden" value={customParam_passengerid} readOnly/>
            <input name="customParam_schoolname" type="hidden" value={customParam_schoolname} readOnly/>
            <input name="customParam_studentname" type="hidden" value={customParam_studentname} readOnly/>
            <input name="hashExtended" type="hidden" value={generateHashExtended()} readOnly/>
            <input name="hash_algorithm" type="hidden" value={hash_algorithm} readOnly/>
            <input name="mode" type="hidden" value={mode} readOnly/>
            <input name="oid" type="hidden" id="orderId" value={oid} readOnly/>
            <input name="responseFailURL" type="hidden" value={responseFailURL} readOnly/>
            <input name="responseSuccessURL" type="hidden" value={responseSuccessURL} readOnly/>
            <input name="transactionNotificationURL" type="hidden" value={transactionNotificationURL} readOnly/>
            <input type="hidden" name="authenticateTransaction" value={authenticateTransaction}/>
            <input name="storename" type="hidden" value={storename} readOnly/>
            {/* <input name="paymentMethod" type="hidden" value={paymentMethod} readOnly/> */}
            <input name="timezone" type="hidden" value={timezone} readOnly/>
            <input name="txndatetime" type="hidden" value={txndatetime} readOnly/>
            <input name="txntype" type="hidden" value={txntype} readOnly/>
            <input name="trxOrigin" type="hidden" value={trxOrigin} readOnly/>
            {/* Amount:<p/> */}
            <STC.InputGroup>
            <STC.Form.Control required name="chargetotal" type="number" step={0.01} max={10000}  value={chargetotal} onChange={(e) => setChargeTotal(e.target.value)} />
            <STC.Button type="submit" disabled={sending}>Pay now</STC.Button>
            </STC.InputGroup>
        </form>

        <STC.Modal size='xl' className='confirm-form-modal' show={showModal} onHide={() => {if(!sending){setShowModal(false)}}}>
            <STC.Modal.Header className='confirm-header'><strong>{sendingAuthiPay ? 'Redirecting...' : 'Confirm Payment:'}</strong></STC.Modal.Header>
            <STC.Modal.Body>
                {!sendingAuthiPay && 
                <div>
                    {latestPayment && <>{(format(new Date(latestPayment.createdDate), 'dd/LLL/yyyy') === format(new Date(), 'dd/LLL/yyyy')) &&
                        <STC.Alert variant='warning'><strong>Please note:</strong> You have already made a payment of <strong>{(latestPayment?.amount ?? 0).toLocaleString('en-IE', {minimumFractionDigits: 2,maximumFractionDigits: 2})} {tour.currency}</strong> for this passenger and tour today at <strong>{format(new Date(latestPayment.createdDate), 'HH:mm aaaa')}</strong></STC.Alert>
                    }</>}
                    <div className='m-2'>Are you sure you want to make this payment?</div> 
                    <STC.Row className='m-2'>
                        <STC.Col sm={3}><strong>School</strong></STC.Col>  
                        <STC.Col>{tour.schoolName}</STC.Col>  
                    </STC.Row>
                    <STC.Row className='m-2'>
                        <STC.Col sm={3}><strong>Tour</strong></STC.Col>  
                        <STC.Col>{tour.bookingId}: {tour.destinations.map((dest) => dest)}</STC.Col>  
                    </STC.Row>
                    <STC.Row className='m-2'>
                        <STC.Col sm={3}><strong>Passenger</strong></STC.Col>
                        <STC.Col>{passenger.firstName}  {passenger.surname}</STC.Col>
                    </STC.Row>
                    <STC.Row className='m-2'>
                        <STC.Col sm={3}><strong>Amount</strong></STC.Col>
                        <STC.Col>{chargetotal} {tour.currency}</STC.Col>
                    </STC.Row>
                </div>}
                {sendingAuthiPay &&
                    <div className='message-container'>
                                <ColouredLoadingSymbol  />
                              </div>
                }
            </STC.Modal.Body>
            <STC.Modal.Footer>
                <STC.Button className='clear' disabled={sendingAuthiPay} onClick={() => handleCancelPayNow()}>Cancel</STC.Button>
                <STC.Button className='confirm' disabled={sendingAuthiPay} onClick={() => handleConfirmPayment()}>{sendingAuthiPay ? 'Redirecting...' : 'Confirm'}</STC.Button>
            </STC.Modal.Footer>
        </STC.Modal>
        </>
    )
}

